import React from 'react';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import {lazy} from '@aboutyou/lazy-imports';

export const ArticleDetail = lazy(
  () =>
    import('./ArticleDetail.eager').then(mod => ({default: mod.ArticleDetail})),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
